import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

const Countdown = () => {
  const deadline = new Date('November 21, 2025 10:00:00 GMT+01:00');
  const [days, setDays] = useState(0);
  const [timer, setTimer] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const { t } = useTranslation();

  useEffect(() => {
    const calculateTimeLeft = () => {
      const currentDate = new Date();
      const timeLeft = deadline.getTime() - currentDate.getTime();

      const days = Math.floor(timeLeft / (24 * 60 * 60 * 1000));
      const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
      const minutes = 59 - currentDate.getMinutes();
      const seconds = 59 - currentDate.getSeconds();

      setDays(days);
      setTimer({ hours, minutes, seconds });
    };

    calculateTimeLeft();
    const intervalId = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(intervalId);
  }, [deadline]);

  return (
    <div className="countdown text-center">
      <div className="card nigiri my-3">
        <div className="p-5">
          <h4 className="text-5xl text-white my-2">Vorverkauf startet in:</h4>
          <h3>
            <span className="superhead d-inline-block text-white">
              {days} : {timer.hours} : {timer.minutes} : {timer.seconds}
            </span>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Countdown);
